<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div>
        <div class="footer app-ban" :style="{ paddingLeft: isMobile == 'PC' ? '50px' : '30px' }">
            <div class="bigbox" :class="{ flex: isMobile == 'PC' }">
                <div class="nav  flex" :style="{ width: isMobile == 'PC' ? '100%' : '' }">
                    <div v-for="(item, index) in arrList" :key="index" class="one"
                        :style="{ width: isMobile == 'PC' ? '16%' : '52%', marginBottom: isMobile == 'PC' ? '100px' : '60px' }">
                        <h6 class="h6-text">{{ item.txt }}</h6>
                        <p class="p-text" v-for="(items, indexs) in item.children" :key="indexs"><router-link
                                :to="items.link" class="a-link">{{ items.tit }}</router-link></p>
                    </div>
                    <div :style="{ width: isMobile == 'PC' ? '16%' : '52%', marginBottom: isMobile == 'PC' ? '100px' : '60px' }"
                        class="abouts">
                        <h6 class="h6-text">{{ footerText.findUs }}</h6>
                        <h4 class="h4-text">{{ footerText.handle }}</h4>
                        <div class="flex abouts-div"><img :src="item.logo" alt="" class="abouts-us" v-for="(item, index) in findList"
                                :key="index"></div>
                    </div>
                    <div
                        :style="{ width: isMobile == 'PC' ? '' : '52%', marginBottom: isMobile == 'PC' ? '100px' : '60px', position: 'relative' }">
                        <h6 class="h6-text">{{ footerText.links }}</h6>
                        <p class="p-text" v-for="(item, index) in friendsList" :key="index"><a :href="item.url" target="_blank">{{ item.name }}</a></p>
                    </div>
                </div>
            </div>
            <div :style="{textAlign: isMobile == 'PC' && 'center'}"><p> <a  :style="{textAlign:'left',display:' inline-block'}" href="//beian.miit.gov.cn" target="_blank">
                <span  :style="{display:'block'}">© 2025 MSAM   
                </span>
                <span :style="{display:'block', marginTop:'-10px'}">京ICP备14031943号-2</span>
                <!-- <img src="../assets/beian1.png" alt="" class="beian"> -->
            </a></p></div>
        </div>
    </div>

</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { getfriendList } from "../utils/gerData";
import { currentLanguage } from "../utils/lang";
import { headerLabels, footerLabels,imageurl } from "../utils/i18nLabels";
const isMobile = localStorage.getItem('userAgent')
const friendsList = ref([])
const findList = ref([])
const arrList = computed(() => {
    const lang = currentLanguage.value || 'zh'
    return headerLabels.sections.map(section => ({
        txt: section.title[lang],
        children: section.items.map(it => ({ tit: it.label[lang], link: it.to }))
    }))
})

const footerText = computed(() => {
    const lang = currentLanguage.value || 'zh'
    return {
        links: footerLabels.links[lang],
        findUs: footerLabels.findUs[lang],
        handle: footerLabels.handle[lang]
    }
})
// 获取列表数据
function getList() {
    let queryParams = {
        page: 1,
        pageSize: 100,
        category_id: 1
    }
    getfriendList(queryParams).then(res => {
        const data = res.data
        friendsList.value = data.list;
    });
    let queryParams1 = {
        page: 1,
        pageSize: 100,
        category_id: 3
    }
    getfriendList(queryParams1).then(res => {
        const data = res.data
        data.list.map(item => {
            item.logo = item.logo ? imageurl + item.logo : undefined
        })
        findList.value = data.list;
    });
}
getList()
watch(currentLanguage, () => {
    getList()
})
</script>

<style scoped>
.footer {
    background: rgb(18, 18, 18);
    color: white;
    font-size: 14px;
    padding: 50px 60px;
    text-align: left;

    h6 {
        font-weight: normal;
        font-size: 18px;
        margin-bottom: 8px;
    }

    h4 {
        font-weight: normal;
        font-size: 12px;
        margin-bottom: 12px;
    }

    p {
        line-height: 34px;

        a {
            color: white;
        }
    }

    .bigbox {
        align-items: flex-start;
    }

    .nav {
        flex-wrap: wrap;
        align-items: flex-start;

        p:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .new {
        justify-content: space-between;
    }

    .abouts {
        .abouts-div {
            justify-content: flex-start;

            .abouts-us {
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
        }
        /* div {
            justify-content: flex-start;

            .us {
                width: 20px;
                margin-right: 10px;
            }
        } */
    }

    .beian {
        margin-top: 20px;
        width: 140px;
    }
}

/* 平板和iPad适配 */
@media (min-width: 769px) and (max-width: 1400px) {
    .footer {
        padding: 40px 30px; /* 减少padding */
        .h6-text {
            font-weight: normal;
            font-size: 18px;
            margin-bottom: 8px;
        }
        .p-text {
            line-height: 34px;

            .a-link {
                color: white;
            }
        }
        .h4-text {
            font-weight: normal;
        font-size: 12px;
        margin-bottom: 12px;
        }
    }
    
    .abouts {
        .abouts-div {
            justify-content: flex-start;
            
            .abouts-us {
                width: 20px !important;  /* 增大图片尺寸 */
                height: 20px !important;
                margin-right: 10px !important;
            }
        }
    }

    .bigbox {
        align-items: flex-start;
    }

    .nav {
        flex-wrap: wrap;
        align-items: flex-start;

        .p-text:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .new {
        justify-content: space-between;
    }

    
    .beian {
        margin-top: 10px;
        width: 120px; /* 减小编码图片尺寸 */
    }
}

</style>
